// extracted by mini-css-extract-plugin
export default {"content":"Orders_content__KI0FS","order":"Orders_order__44W9Z","text":"Orders_text__tnYmQ"};